"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styled_components_1 = require("styled-components");

var react_select_1 = __importDefault(require("react-select"));

var components_1 = require("./components");

var defaultSettings = {
  size: "default",
  hideIndicatorSeparator: false,
  hideDropdownIndicator: false,
  hideIndicatorsContainer: false,
  menuWidth: undefined,
  menuItems: undefined,
  valueItems: undefined
};
/**
 * Select component - extended and customized Select from https://react-select.com/
 */

var Select = function Select(_a) {
  var customSettings = _a.customSettings,
      options = _a.options,
      value = _a.value,
      _a$isSearchable = _a.isSearchable,
      isSearchable = _a$isSearchable === void 0 ? false : _a$isSearchable,
      rest = __rest(_a, ["customSettings", "options", "value", "isSearchable"]);

  var theme = react_1.useContext(styled_components_1.ThemeContext);

  var _Object$assign = Object.assign(Object.assign({}, defaultSettings), customSettings),
      _Object$assign$size = _Object$assign.size,
      size = _Object$assign$size === void 0 ? "default" : _Object$assign$size,
      _Object$assign$hideIn = _Object$assign.hideIndicatorSeparator,
      hideIndicatorSeparator = _Object$assign$hideIn === void 0 ? false : _Object$assign$hideIn,
      _Object$assign$hideDr = _Object$assign.hideDropdownIndicator,
      hideDropdownIndicator = _Object$assign$hideDr === void 0 ? false : _Object$assign$hideDr,
      _Object$assign$hideIn2 = _Object$assign.hideIndicatorsContainer,
      hideIndicatorsContainer = _Object$assign$hideIn2 === void 0 ? false : _Object$assign$hideIn2,
      menuWidth = _Object$assign.menuWidth,
      _Object$assign$menuIt = _Object$assign.menuItems,
      menuItems = _Object$assign$menuIt === void 0 ? [] : _Object$assign$menuIt,
      _Object$assign$valueI = _Object$assign.valueItems,
      valueItems = _Object$assign$valueI === void 0 ? [] : _Object$assign$valueI;

  return react_1["default"].createElement(react_select_1["default"], Object.assign({
    size: size,
    menuWidth: menuWidth,
    hideIndicatorSeparator: hideIndicatorSeparator,
    hideDropdownIndicator: hideDropdownIndicator,
    hideIndicatorsContainer: hideIndicatorsContainer,
    menuItems: menuItems,
    valueItems: valueItems,

    /** react select */
    value: value,
    options: options,
    isSearchable: isSearchable,
    theme: theme || {},
    components: {
      Control: components_1.Control,
      SelectContainer: components_1.SelectContainer,
      ValueContainer: components_1.ValueContainer,
      Menu: components_1.Menu,
      MenuList: components_1.MenuList,
      Option: components_1.Option,
      SingleValue: components_1.SingleValue,
      IndicatorSeparator: components_1.IndicatorSeparator,
      IndicatorsContainer: components_1.IndicatorsContainer,
      DropdownIndicator: components_1.DropdownIndicator,
      Group: components_1.Group,
      GroupHeading: components_1.GroupHeading
    }
  }, rest));
};
/*
ClearIndicator: IndicatorComponentType<OptionType> | null;
DownChevron: ComponentType<any>;
CrossIcon: ComponentType<any>;
Input: ComponentType<InputProps>;
LoadingIndicator: ComponentType<LoadingIconProps<OptionType>> | null;
MenuPortal: ComponentType<MenuPortalProps<OptionType>>;
LoadingMessage: ComponentType<NoticeProps<OptionType>>;
NoOptionsMessage: ComponentType<NoticeProps<OptionType>>;
MultiValue: ComponentType<MultiValueProps<OptionType>>;
MultiValueContainer: ComponentType<any>;
MultiValueLabel: ComponentType<any>;
MultiValueRemove: ComponentType<any>;
Placeholder: ComponentType<PlaceholderProps<OptionType>>;
*/


exports["default"] = Select;